module.exports = __webpack_public_path__ + "img/49.8e23d0e0.png";